export default __webpack_public_path__ + "static/media/shield-dark.671d632e.png";